import { render } from "./ShipperSurveyComponent.vue?vue&type=template&id=ae0b73de"
import script from "./ShipperSurveyComponent.vue?vue&type=script&lang=js"
export * from "./ShipperSurveyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__